import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Close as CloseIcon } from "components/MaterialSymbol/MaterialIcons";

const useStyles = makeStyles(() => ({
    titleRoot: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "16px 24px 8px",
    },
    titleText: {
        fontSize: "1.125rem",
        fontWeight: 600,
        lineHeight: 1.3,
    },
    closeButton: {
        color: "#6B7280",
        marginRight: -8,
        padding: 8,
    },
}));

const BasicDialog = ({ open = false, onClose, title = "", children, ...otherProps }) => {
    const classes = useStyles();

    return (
        <Dialog open={open} onClose={onClose} {...otherProps}>
            <DialogTitle disableTypography className={classes.titleRoot}>
                <Typography className={classes.titleText}>{title}</Typography>
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {children}
                {/*<Button onClick={onClose} color="primary">
                    Cerrar
                </Button>*/}
            </DialogContent>
        </Dialog>
    );
};

export default BasicDialog;
